
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1303Dialog extends Serenity.EntityDialog<Report_1303Row, any> {
        protected getFormKey() { return Report_1303Form.formKey; }
        protected getIdProperty() { return Report_1303Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1303Row.localTextPrefix; }
        protected getNameProperty() { return Report_1303Row.nameProperty; }
        protected getService() { return Report_1303Service.baseUrl; }
        protected getDeletePermission() { return Report_1303Row.deletePermission; }
        protected getInsertPermission() { return Report_1303Row.insertPermission; }
        protected getUpdatePermission() { return Report_1303Row.updatePermission; }

        protected form = new Report_1303Form(this.idPrefix);

    }
}